const INITIAL_STATE = {
    data: null
}

const cadastroEstabelecimentoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'cadastroEstabelecimento': {

            return {
                ...state,
                data: action.payload.dadosCadastroEstabelecimento
            }
        }
        default: {
            return state
        }
    }
}

export default cadastroEstabelecimentoReducer
